
//import { CoordinateProcessor } from '../../utils/CoordinateProcessor';
import { useMapStore } from "../../store/useMapStore.js";
import { wgs84ToWebMercator } from "../../services/CoordinateTransformService.js";
import { BBOxRelativeToCenter, wgsRelativeToCenter , mercatorRelative} from "../../services/MercatorRelativeToCenter.js";
import Delaunator from "delaunator";


export class TopographyEntity {
    
    
    constructor(data = {}, crs) {
       
      
        if(crs == "EPSG25833" || crs == "EPSG3857"|| crs == "EPSG25832"){
             this.name = "TopographyEntity",
            this.breitengrad = data.metadata.origin.latitude.toFixed(4) + ' °'|| "",  //not in the database
            this.laengengrad = data.metadata.origin.longitude.toFixed(4) + ' °' || "", //not in the database
            this.nhn = data.metadata.origin.elevation.toFixed(4) +' m' || "",
            this.referenceSystem = "DHHN2016",
            this.center = useMapStore.getState().center //TopographyEntity.getCenterElevation(useMapStore.getState().center,this.nhn);
            this.elevationRange =  data.metadata.elevationRange;
            this.mercatorCoordinates= data.points;
            

        }
        else{
           
            this.mercatorCoordinates = TopographyEntity.wgsRelative(data.points, useMapStore.getState().center);
            console.log("Write function to handle wgs ",  data)
        }
    }


    static wgsRelative(coordinates) 
    {
        // Map through all coordinate arrays to maintain structure
        const mercatorArray = coordinates.map(points => {
            // Map through each point in the current coordinate array
            
                const pointsarray = {
                    lng: points.x,  // First element is longitude
                    lat: points.y,  // Second element is latitude
                    elv: points.z,  // Third element is elevation
                };
                return wgsRelativeToCenter(pointsarray, useMapStore.getState().center);
          
        });
        
        return mercatorArray;
    }
    // Static method to create multiple entities from raw response
    static fromResponse(response,crs) 
    {
        
        // Check if the response structure matches your expected format
        if (response)
        {
          
            return new TopographyEntity(response.data.topographyAsPointList, crs);
            
        }
        return [];
    }
    static mercatorRelativeTopo(coordinates) 
    {
      const center = useMapStore.getState().center 
      
        // Map through all coordinate arrays to maintain structure
        const mercatorArray = coordinates.map(points => {
            // Map through each point in the current coordinate array
            const pointsarray = {
                    lng: points.x,  // First element is longitude
                    lat: points.y,  // Second element is latitude
                    elv: points.z,  // Third element is elevation
                    }
                
                return BBOxRelativeToCenter(pointsarray, center);
           
        });
        
        return mercatorArray;
    }
    static getCenterElevation(mapCenter, originElevation)
    {
        const centerElevationArray ={
            lat: mapCenter.lat,
            lng: mapCenter.lng,
            elv: originElevation
        };
        return centerElevationArray;

    }
}